import React from 'react';
import { classNames } from '~/utils/classNames';

export type PillType = 'image' | 'figma' | 'asset' | 'annotation';

interface InputPillProps {
  type: PillType;
  label: string;
  onRemove?: () => void;
}

export const InputPill: React.FC<InputPillProps> = ({ type, label, onRemove }) => {
  const typeConfig = {
    image: {
      color: 'text-blue-400',
      bg: 'bg-blue-400/10',
      border: 'border-blue-400/20',
      icon: 'i-ph:image',
    },
    figma: {
      color: 'text-purple-400',
      bg: 'bg-purple-400/10',
      border: 'border-purple-400/20',
      icon: 'i-ph:figma-logo',
    },
    asset: {
      color: 'text-green-400',
      bg: 'bg-green-400/10',
      border: 'border-green-400/20',
      icon: 'i-ph:paperclip',
    },
    annotation: {
      color: 'text-yellow-400',
      bg: 'bg-yellow-400/10',
      border: 'border-yellow-400/20',
      icon: 'i-ph:cursor-click',
    },
  }[type];

  return (
    <span
      className={classNames(
        'group inline-flex items-center gap-1.5 px-2 py-0.5 mx-0.5 rounded-md text-xs font-medium border transition-all select-none align-middle animate-in fade-in zoom-in duration-200',
        'shadow-sm',
        typeConfig.bg,
        typeConfig.border,
        'hover:brightness-110',
      )}
      contentEditable={false}
    >
      <div className="flex items-center justify-center w-4 h-4 -ml-1 shrink-0">
        {onRemove ? (
          <button
            type="button"
            onMouseDown={(e) => e.preventDefault()} // Prevent loss of focus on editor
            onClick={(e) => {
              e.stopPropagation();
              onRemove();
            }}
            className="flex items-center justify-center w-full h-full rounded-full transition-colors"
            title="Remove"
          >
            <div className={classNames(typeConfig.icon, 'text-xs', typeConfig.color, 'group-hover:hidden')} />
            <div className="i-ph:x text-[10px] text-dualite-text-secondary hidden group-hover:block" />
          </button>
        ) : (
          <div className={classNames(typeConfig.icon, 'text-xs', typeConfig.color)} />
        )}
      </div>

      <span className="max-w-[150px] truncate leading-tight">{label}</span>
    </span>
  );
};
